<div [matBadge]="item.quantity">
  <img [ngSrc]="image|fileurl" width="60" height="75" alt="product" />
</div>
<div class="info">
  <span class="name">{{item.product.name}}</span>
  <div class="attrs">
    @for (attr of attrs; track $index) {
    <span
      >{{attr.attr.name}}: <span class="value">{{attr.value.name}}</span>
    </span>
    }
    <span
      >{{priced_attr?.attr?.name}}:
      <span class="value">{{priced_attr?.value?.name}}</span>
    </span>
  </div>
</div>
<app-price [price]="item.amount"></app-price>
